import { gql } from "@apollo/client";

export const EXIST_CODIGO_SAP_BY_ID_DEPOSITO = gql`
query existCodigoSAPByIdDeposito($idDeposito: Int!, $codigoSAP: String!){
    existCodigoSAPByIdDeposito(idDeposito: $idDeposito, codigoSAP: $codigoSAP)  
    }
`;